<template>
  <b-modal
    title="Biztosan vissza akar térni az előző lépéshez?"
    ref="goback-popup"
    id="goback-popup"
    hide-footer
    size="xl"
  >
    <div class="d-block text-left mb-5 p-2 pr-5 pt-0">
      <p>A jelenlegi módosításai el fognak veszni, ha visszatér az előző lépéshez.</p>
      <br />
      <div align-self="center" class="ctrl-btn">
        <b-button class="mt-4 btn-secondary mr-5" variant="secondary" @click="goBack">Vissza az előző lépésre</b-button>
        <b-button class="mt-4 ml-lg-2 ml-xl-2 ml-0" variant="primary" @click="showLoginModal">
          Szerkesztés folytatása
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'GoBackPopup',
  props: {
    step: Number
  },
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  methods: {
    showLoginModal() {
      this.$refs['goback-popup'].hide()
    },
    goBack() {
      this.$refs['goback-popup'].hide()
      const path = `/competitions/competition/${this.step}`
      this.$router.push({ path, query: { competitionId: this.$route.query.competitionId } })
    }
  }
}
</script>

<style scoped>
::v-deep #goback-popup .modal-content {
  background-color: #ffffff;
  padding-left: 5rem;
}

::v-deep #goback-popup .modal-header {
  border-bottom: 0px;
}

::v-deep #goback-popup .modal-title {
  color: black !important;
  padding-top: 4rem;
  padding-right: 5rem;
  padding-left: 0.5rem;
  font-size: 64px;
  line-height: 75px;
  color: #484443;
  font-weight: normal;
}

h1 {
  color: white;
}

.btn {
  min-width: 280px;
}

a {
  color: white;
  text-decoration: underline;
}

p {
  color: #636e72;
  margin: 0;
}

@media (max-width: 993px) {
  ::v-deep #goback-popup .modal-title {
    font-size: 32px;
    line-height: 38px;
  }
  ::v-deep #goback-popup .modal-content {
    padding-left: 1rem;
  }
  ::v-deep #goback-popup .modal-title {
    padding-top: 2rem;
    padding-right: 3rem;
  }
  .ctrl-btn > .btn {
    width: 100%;
  }
}
</style>
